import React from "react"
import { translations } from "../../utils/Translation/staticTranslation"
import { getAppLanguage } from "../../utils/getAppLanguage"
import {
  getOrganizationMembersSummaryFromOverview,
  hasOrganizationFurnitureFinderPool,
} from "../../utils/organizationApiHelpers"

const OrganizationStats = ({ overview }) => {
  const lang = getAppLanguage()
  const t = translations[lang]?.organizationPage?.stats
  const org = overview?.organization
  const sub = overview?.subscription
  const counts = getOrganizationMembersSummaryFromOverview(overview)

  const formatDate = (iso) => {
    if (!iso) return "—"
    try {
      return new Date(iso).toLocaleDateString(lang === "ar" ? "ar-SA" : "en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
      })
    } catch {
      return iso
    }
  }

  const showFurnitureFinder = hasOrganizationFurnitureFinderPool(overview)

  const imageCards = [
    {
      label: t?.plan || "Plan",
      value: org?.plan_name || "—",
      sub: org?.name,
    },
    {
      label: t?.totalPool || "Total images",
      value: sub?.total_images ?? "—",
    },
    {
      label: t?.unallocated || "Unallocated",
      value: sub?.unallocated_images ?? "—",
      highlight: true,
    },
    {
      label: t?.activeMembers || "Active members",
      value: counts?.active ?? 0,
      sub: `${t?.invited || "Invited"}: ${counts?.invited ?? 0}`,
    },
    {
      label: t?.ends || "Subscription ends",
      value: formatDate(sub?.subscription_end),
    },
  ]

  const furnitureFinderCards = showFurnitureFinder
    ? [
        {
          label: t?.totalFurnitureFinder || "Furniture Finder pool",
          value: sub?.total_furniture_finder ?? sub?.plan_furniture_finder ?? "—",
        },
        {
          label: t?.unallocatedFurnitureFinder || "FF unallocated",
          value: sub?.unallocated_furniture_finder ?? "—",
          highlight: true,
        },
      ]
    : []

  const renderCards = (cards) =>
    cards.map((card) => (
      <div
        key={card.label}
        className={`org-stat-card${card.highlight ? " org-stat-card--highlight" : ""}`}
      >
        <span className="org-stat-label">{card.label}</span>
        <span className="org-stat-value">{card.value}</span>
        {card.sub ? <span className="org-stat-sub">{card.sub}</span> : null}
      </div>
    ))

  return (
    <div className="org-stats-wrap">
      <div className="org-stats-grid">{renderCards(imageCards)}</div>
      {furnitureFinderCards.length > 0 ? (
        <div className="org-stats-section">
          <h3 className="org-stats-section-title">
            {t?.furnitureFinderSection || "Furniture Finder"}
          </h3>
          <div className="org-stats-grid org-stats-grid--furniture-finder">
            {renderCards(furnitureFinderCards)}
          </div>
        </div>
      ) : null}
    </div>
  )
}

export default OrganizationStats
